import {
  FETCH_MY_ASSESSMENTS,
  FETCH_MY_ASSESSMENTS_SUCCESS,
  FETCH_MY_ASSESSMENTS_ERROR,
} from '../actions/types';

const DEFAULT_STATE = {
  loading: false,
  error: null,
  data: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case FETCH_MY_ASSESSMENTS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case FETCH_MY_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case FETCH_MY_ASSESSMENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/myAssessmentsReducer.js